import { configureStore } from '@reduxjs/toolkit';
import userSlice from './userSlice';

export default configureStore({
  reducer: {
    user: userSlice    //碎片的name：碎片
  },
});